import en from './en';
import zhCN from './zh-CN';

export default {
  en,
  'zh-CN': zhCN,
};



// WEBPACK FOOTER //
// ./src/locales/index.js